import { createServidorApi } from "@/contexts/cadastro/servidor/api/servidorApi";
import { Servidor } from "@/contexts/cadastro/servidor/model/Servidor";
import {
  getServidoresSynced,
  servidorAction,
} from "@/contexts/cadastro/servidor/store/servidorSlice";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useServidor = () => {
  const { user } = useAuth();
  const servidorApi = createServidorApi(user?.access_token);
  const listaServidores = useSelector(getServidoresSynced);
  const appDispatch = useDispatch();
  const { sync } = servidorAction;

  const sincronizarServidores = (servidores: Servidor[]) => {
    appDispatch(sync(servidores));
  };

  const getServidoresApi = servidorApi.listAll;

  const getServidorLogged = () => {
    return listaServidores.find(
      (servidor) => servidor.pessoa.cpfCnpj === user?.profile.cpf
    );
  };

  return {
    listaServidores,
    sincronizarServidores,
    getServidoresApi,
    getServidorLogged,
  };
};
